import { render } from "./AiCalendar.vue?vue&type=template&id=6b81010b&scoped=true"
import script from "./AiCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCalendar.vue?vue&type=script&setup=true&lang=js"

import "./AiCalendar.vue?vue&type=style&index=0&id=6b81010b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b81010b"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b81010b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b81010b', __exports__)) {
    api.reload('6b81010b', __exports__)
  }
  
  module.hot.accept("./AiCalendar.vue?vue&type=template&id=6b81010b&scoped=true", () => {
    api.rerender('6b81010b', render)
  })

}


export default __exports__